import React from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import {useSelector} from "react-redux";

import UserPanel from "../UserPanel/UserPanel";

import './Navigation.style.scss'
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import useAppModalService from "../../hooks/useAppModalService";
import ContactUs from "../ContactUs/ContactUs";
import DropdownMenu from "../DropDownMenu/DropDownMenu";
import GlobalConst from "../../constants/GlobalConst";
import {selectUserIsAuthenticated} from "../../stores/account/account.selectors";
import {ModalType} from "../AppModal/ModalTypes";
import OnBoardingPopUp from "../../views/PopUps/OnBoardingPopUp/OnBoardingPopUp";


const NavigationHeader = (props) => {
    const navigate = useNavigate();
    const {openModal} = useAppModalService();
    const isUserIsAuthenticated = useSelector(selectUserIsAuthenticated);

    const handleHelpMenuClick = (link) => {
        navigate(link);
    }

    const handleContactUsClick = async () => {
        await openModal('contactUs', ModalType.CUSTOM, {
            modalComponent: ContactUs
        });
    };

    const handleOnboardingClick = async ()=>{
        await openModal("onBoardingPopUp", ModalType.CUSTOM, {
            modalComponent: OnBoardingPopUp
        })
    }

    return (
        <div className="NavigationHeader">
            <div className="container">
                <div className="links">
                    <Link
                        to="/lobby"
                        className={"navLogo"}
                    />
                    <ul>
                        {/*<li className="tradefanFantasy">
                            <Link to={`${GlobalConst.SITE_URLS.TRADEFAN}`}>
                                <FormattedMessage id={"navigationHeader.liveFantasy"}/>
                            </Link>
                        </li>
                        <li>
                            <div className="sep"></div>
                        </li>*/}
                        <li>
                            <Link to={"/lobby"}>
                                <FormattedMessage id={"navigationHeader.lobby"}/>
                            </Link>
                        </li>
                        <li>
                            <DropdownMenu
                                activator={
                                    <div className={"help"}>
                                        <span><FormattedMessage id="navigationHeader.help"/></span>
                                        <KeyboardArrowDownIcon className="arrowDownIcon"/>
                                    </div>
                                }>
                                <div className="menu-item"
                                     onClick={() => handleHelpMenuClick("/howtoplay")}>
                                    <FormattedMessage id={"navigationHeader.howToPlay"}/>
                                </div>
                                <div className="menu-item"
                                     onClick={() => handleHelpMenuClick("/faq")}>
                                    <FormattedMessage id={"navigationHeader.faq"}/>
                                </div>
                                <div className="menu-item"
                                     onClick={() => handleOnboardingClick()}>
                                    <FormattedMessage id={"navigationHeader.onboarding"}/> <div className={"icon-video"}></div>
                                </div>
                                <div className="menu-item"
                                     onClick={() => handleContactUsClick()}>
                                    <FormattedMessage id={"navigationHeader.contactUs"}/>
                                </div>
                            </DropdownMenu>
                        </li>
                        {isUserIsAuthenticated && <li>
                            <Link to={`myaccount/mypicks/ongoing`}>
                                <FormattedMessage id={"navigationHeader.myAccount.myPicks"}/>
                            </Link>
                        </li>}
                    </ul>


                </div>
                <UserPanel/>
            </div>
        </div>
    )
}

export default NavigationHeader;